const isRemovable = ({ optionDefaults, product }) => {
  const sizes = product?.sizes || [];
  const isInRecipe = optionDefaults?.inRecipe;
  // business logic dictates that if a qty-based productOption is in the recipe
  // and does not have a `no` sizeCode available, it should not be removable
  const hasNoSizeCode = sizes.find((size) => {
    return size.sizeCode === 'no';
  });
  if (!isInRecipe || (isInRecipe && hasNoSizeCode)) {
    return true;
  }
  return false;
};

export default isRemovable;
